export default __webpack_public_path__ + "static/media/my-image.cf82bc02.jpg";